<template>
  <v-select
    v-bind="$attrs"
    v-on="$listeners"
    v-model="selected"
    :menu-props="{ offsetY: true, overflowY: true, closeOnContentClick: true }"
    :items="items"
    item-text="text"
    item-value="value"
  >
    <template slot="item" slot-scope="{ item, index }">
      {{ $t(`academic_title.${item.toLowerCase()}`) }}
    </template>

    <template slot="selection" slot-scope="{ item, index }">
      {{ $t(`academic_title.${item.toLowerCase()}`) }}
    </template>
  </v-select>
</template>

<script>
  import academicTitles from "./academicTitles";

  export default {
    inheritAttrs: false,
    name: "AcademicTitlePicker",
    props: {
      value: [String, Array]
    },
    data: () => ({
      items: academicTitles,
      selected: null
    }),
    watch: {
      value: {
        handler(v) {
          this.selected = v;
        },
        immediate: true
      }
    }
  };
</script>

<style scoped></style>
